export const VACATION_HOME = {
  nickname: 'PRODUCTS.VACATION_HOME.nickname',
  properties: [
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO' },
    { name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'INSURANCE_INFO' },
    { name: 'objectZipCode', key: 'OBJECT_ZIP', group: 'INSURANCE_INFO' },
    { name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO' },
    { name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO' },
    { name: 'houseSumInsuredType', key: 'SUM_INSURED_TYPE', group: 'INSURANCE_INFO' },
    { name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO' },
  ],
  icon:'vacation-home'
};
